import React from "react"

const useWindowHeight = () => {
  const [size, setSize] = React.useState(0)

  React.useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        setSize(document.documentElement.scrollHeight)
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return size
}

export default useWindowHeight
